export default __webpack_public_path__ + "static/media/O.e86e2775.svg";